import { combineReducers } from 'redux';
import { CoughAnalysisScreenState, initialScreenState, screenReducer } from '../cough-analysis/CoughAnalysisReducer';
import { ImportEventsState, initialImportEvents, importEventsReducer } from '../cough-analysis/import-events/ImportEventsReducer';
import { ManuallySendState, initialManuallySend, manuallySendReducer } from '../cough-analysis/ManuallySendForQAModal/ManuallySendReducer';
import { AssignToUserState, initialAssignToUser, assignToUserReducer } from '../cough-analysis/AssignToUserModal/AssignToUserModalReducer';
import { SecurityState, initialSecurityState, securityReducer } from './SecurityReducer';
import { CoreState, initialCoreState, coreReducer } from './CoreReducer';
import { CoughSessionsListState, initialCoughSessionsListState, coughSessionsListReducer } from '../cough/SessionsList/CoughSessionsListReducer';
import { ReportsState, initialReportsState } from '../reports/ReportsState';
import reportsReducer from '../reports/ReportsReducer';

export interface MainState {
    core: CoreState;
    security: SecurityState;
    coughSessionsList: CoughSessionsListState;
    coughAnalysisScreen: CoughAnalysisScreenState;
    importEvents: ImportEventsState;
    manuallySendModal: ManuallySendState;
    assignModal: AssignToUserState;
    reports: ReportsState;
}

export const initialState: MainState = {
    core: initialCoreState,
    security: initialSecurityState,
    coughSessionsList: initialCoughSessionsListState,
    coughAnalysisScreen: initialScreenState,
    importEvents: initialImportEvents,
    manuallySendModal: initialManuallySend,
    assignModal: initialAssignToUser,
    reports: initialReportsState,
}

export default combineReducers<MainState>({
    core: coreReducer,
    security: securityReducer,
    coughSessionsList: coughSessionsListReducer,
    coughAnalysisScreen: screenReducer,
    importEvents: importEventsReducer,
    manuallySendModal: manuallySendReducer,
    assignModal: assignToUserReducer,
    reports: reportsReducer,
});
